import { useMutation } from '@apollo/client';
import { useTranslation } from 'react-i18next';
import { useNotifications, type ApiOptions } from '../helpers';
import { DeleteDataSourceDocument } from './delete.generated';

export const useDeleteDataSource = (options: ApiOptions<typeof DeleteDataSourceDocument> = {}) => {
  const { t } = useTranslation();
  return useMutation(DeleteDataSourceDocument, {
    ...useNotifications(DeleteDataSourceDocument, {
      failure: t('api.common.error_generic'),
      success: t('api.data_sources.delete_success'),
    }),

    update(cache, { data }) {
      if (data?.deleteDataSource?.dataSource == null) return;
      cache.evict({ id: cache.identify(data.deleteDataSource.dataSource) });
    },

    ...options,
  });
};
